import { Add, ArrowForwardIos, AutoAwesome, StickyNote2 } from '@mui/icons-material';
import { Button, Fab, styled, Tooltip } from '@mui/material';
import useProjectStore from '../../useProjectStore';
import GlowBorder from '../../../common/GlowBorder';
import './CanvasButtons.css';

export const CanvasHeaderButton = styled(Button)(({ variant, theme }) => ({
  color: variant === 'contained' ? theme.palette.primary.contrastText : theme.palette.text.primary,
  backgroundColor: variant === 'contained' ? theme.palette.grey[600] : theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  padding: '2px 16px',
  gap: '4px',
  fontSize: '14px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: variant === 'contained' ? theme.palette.grey[700] : theme.palette.action.hover,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.2s ease-in-out',
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.divider,
    color: theme.palette.text.disabled,
  },
}));

const SideMenuFabItem = styled(Fab, {
  shouldForwardProp: prop => prop !== 'fabStyles',
})(({ fabStyles }) => ({
  ...fabStyles,
  width: '40px',
  height: '40px',
  zIndex: '1000 !important',
  borderRadius: '4px',
  padding: '12px',
}));

const CanvasSideMenuButton = ({ tooltip, onClick, icon, fabStyles, showClose, disabled }) => {
  return (
    <Tooltip title={tooltip}>
      <span style={{ display: 'inline-block' }}>
        <SideMenuFabItem fabStyles={fabStyles ? fabStyles : {}} onClick={onClick} disabled={disabled}>
          {showClose ? <ArrowForwardIos className="canvasSideMenuIcon" /> : icon}
        </SideMenuFabItem>
      </span>
    </Tooltip>
  );
};

const StandardCanvasButtonStyles = {
  background: 'var(--color-bg-paper) !important',
  color: 'var(--color-text-primary)',
  marginBottom: '24px',
  border: '1px solid var(--color-divider)',
  boxShadow: 'none',
  '&:hover': {
    color: 'var(--color-text-primary)',
    background: 'var(--color-action-hover) !important',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
};

const BaseButtonStyle = {
  marginBottom: '24px',
  border: 'none',
  boxShadow: 'none',
};

const ComponentButtonStyles = {
  ...BaseButtonStyle,
  background: 'var(--color-bg-paper) !important',
  color: 'var(--color-text-primary)',
  border: '1px solid var(--color-divider)',
  '&:hover': {
    color: 'var(--color-text-primary)',
    background: 'var(--color-action-hover) !important',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
};

const NotesButtonStyles = {
  ...BaseButtonStyle,
  background: 'var(--color-bg-paper) !important',
  color: 'var(--color-text-primary)',
  border: '1px solid var(--color-divider)',
  '&:hover': {
    color: 'var(--color-text-primary)',
    background: 'var(--color-action-hover) !important',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },
};

export const ComponentMenuCanvasButton = ({ onClick, showClose, disabled = false }) => {
  return (
    <CanvasSideMenuButton
      showClose={showClose}
      tooltip="Add a component"
      fabStyles={ComponentButtonStyles}
      onClick={onClick}
      disabled={disabled}
      icon={<Add className="canvasSideMenuIcon" />}
    />
  );
};

export const NoteMenuCanvasButton = ({ onClick, showClose }) => {
  return (
    <CanvasSideMenuButton
      showClose={showClose}
      tooltip="Add a note"
      fabStyles={NotesButtonStyles}
      onClick={onClick}
      icon={<StickyNote2 className="canvasSideMenuIcon" />}
    />
  );
};

export const AIMenuCanvasButton = ({ onClick, active }) => {
  return (
    <Tooltip title={active ? "Close AI Assistant" : "AI Assistant"} placement="bottom" arrow>
      <GlowBorder
        onClick={onClick}
        style={{ cursor: 'pointer', marginRight: 8 }}
        size={30}
        borderRadius={5}
      >
        <AutoAwesome style={{ color: '#FFF', fontSize: 16 }} />
      </GlowBorder>
    </Tooltip>
  );
};
